'use strict';

/*global initialize*/
/*global services*/
/*global isEmpty*/
/*global createObjectCallBack*/
/*global K2Handsontable*/

function ProjectStagePlannedOperationBulk() {
  this.handsontable = null;

  this.init();
}

ProjectStagePlannedOperationBulk.prototype = $.extend({}, {
  constructor: 'ProjectStagePlannedOperationBulk',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $('body').on('click', '.project-stage-planned-operation-bulk', function () {
      _this.showEditForm($(this).data('project_rid'), $(this).data('superior_rid'), $(this).data('callback'));
      return false;
    });
  },

  //----------------------------------------------------------------------------

  replaceProjectRID: function replaceProjectRID($btn, projectRID) {
    var _this = this;

    if ($btn.length) {
      var href = $btn.data('href');
      if (!isEmpty(projectRID)) {
        href = href.replace('%ProjectRID%', projectRID);
      }

      $btn.attr('href', href);
    }

    return _this;
  },

  getHandsontableColumns: function getHandsontableColumns() {
    return [
      {
        data: 'CodeId',
        type: 'text'
      },
      {
        data: 'Name',
        type: 'text'
      },
      {
        data: 'Description',
        type: 'text'
      },
      {
        data: 'Priority',
        type: 'text'
      },
      {
        data: 'CF_Bill',
        type: 'text'
      },
      {
        data: 'CF_TypeOfBilling',
        type: 'text'
      },
      {
        data: 'PlanStartDate',
        type: 'date',
        dateFormat: 'DD.MM.YYYY'
      },
      {
        data: 'PlanEndDate',
        type: 'date',
        dateFormat: 'DD.MM.YYYY'
      },
      {
        data: 'PlannedTimeCalc',
        type: 'text'
      },
      {
        data: 'OriginalPlannedTimeCalc',
        type: 'text'
      },
      {
        data: 'Acronyms',
        type: 'text'
      }
    ];
  },

  getHandsontableColHeaders: function getHandsontableColHeaders() {
    return [
      services.get('translator').trans('project_stage_planned_operation.code'),
      services.get('translator').trans('project_stage_planned_operation.name') + ' *',
      services.get('translator').trans('project_stage_planned_operation.description'),
      services.get('translator').trans('project_stage_planned_operation.priority'),
      services.get('translator').trans('project_stage_planned_operation.bill'),
      services.get('translator').trans('project_stage_planned_operation.type_of_billing.title'),
      services.get('translator').trans('project_stage_planned_operation.date_from_p') + ' *',
      services.get('translator').trans('project_stage_planned_operation.date_to_p') + ' *',
      services.get('translator').trans('project_stage_planned_operation.time_p'),
      services.get('translator').trans('project_stage_planned_operation.time_op'),
      services.get('translator').trans('project_stage_planned_operation.project_spo_resource')
    ];
  },

  initForm: function initForm() {
    var _this = this;

    var modal = services.get('modal');
    initialize(modal.contentDOM());

    var $projectRIDInput = modal.contentDOM().find('.project-stage-planned-operation-project input[data-lookup-field="id"]');
    var $superiorBtn = modal.contentDOM().find('.project-stage-planned-operation-superior').find('.btn');
    $superiorBtn.data('href', $superiorBtn.attr('href'));
    _this.replaceProjectRID($superiorBtn, $projectRIDInput.val());

    $projectRIDInput.on('changeLookupValue', function () {
      var value = $(this).val();
      _this.replaceProjectRID($superiorBtn, value);
    });

    var data = modal.contentDOM().find('[name$="[Data]"]').val();
    if (!isEmpty(data)) {
      data = JSON.parse(data);
    }

    _this.handsontable = new K2Handsontable(modal.contentDOM().find('.handsontable'), {
      data: !isEmpty(data) ? data : [],
      columns: _this.getHandsontableColumns(),
      colHeaders: _this.getHandsontableColHeaders()
    });

    return _this;
  },

  submitForm: function submitForm(params) {
    var _this = this;

    var modal = services.get('modal');
    var $content = modal.contentDOM();
    var $form = $content.find('form');
    $form.find('[name$="[Data]"]').val(JSON.stringify(_this.handsontable.getData()));

    modal.block();
    $.post($form.attr('action'), $form.serialize(), function (res) {
      modal.unBlock();

      if (res.msg === 'SUCCESS') {
        modal.close();
        services.get('notifications').viewSaveMessage();

        if ('callBack' in params && params.callBack && params.callBack in window) {
          window[params.callBack]();
        } else {
          if (services.has('dashboard')) {
            services.get('dashboard').invalidWidgetsByTag('job_queue');
          }
        }
      } else if (res.msg === 'NOT_VALID') {
        modal.content(res.data.html);
        _this.initForm();
        _this.handsontable.setErrors(res.data.errors);
      } else {
        services.get('notifications').viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  showEditForm: function showEditForm(projectRID, superiorRID, callBack) {
    var _this = this;

    var modal = services.get('modal');
    modal.empty().open({
      title: services.get('translator').trans('project_stage_planned_operation.bulk'),
      height: 'auto',
      width: 'xxl',
      minHeight: '400px',
      modalClass: 'project-stage-planned-operation-bulk-form',
      submitCallBack: createObjectCallBack(_this, 'submitForm', { callBack: callBack }),
      form: true,
      keyboardClose: false
    });

    modal.block();
    $.get(services.get('router').path('project_stage_planned_operation_bulk'), { ProjectRID: projectRID, SuperiorRID: superiorRID }, function (res) {
      modal.unBlock();
      if (res.msg === 'SUCCESS') {
        modal.content(res.data.html);
        _this.initForm();
      } else {
        services.get('notifications').viewErrorMessage();
      }
    });

    return _this;
  },

  init: function init() {
    var _this = this;

    _this.registerCallbacks();

    return _this;
  }
});
